import configureProd from './configureStore.prod'
import configureDev from './configureStore.dev'

export default (process.env.NODE_ENV === 'production') ? configureProd : configureDev



// WEBPACK FOOTER //
// ./src/application/store/index.js